import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClick", "alt", "sx", "src"];
import Avatar from "@mui/material/Avatar";
export var MuiAvatar = function (props) {
    var onClick = props.onClick, alt = props.alt, sx = props.sx, src = props.src, other = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/ React.createElement(Avatar, _extends({
        onClick: onClick,
        id: "profile-image-popup",
        sx: sx,
        alt: alt || "",
        src: src
    }, other));
};
